export async function addNewDealer(dataDealer: {
  dealerName: string;
  code: string;
  inn: string;
}) {
  if (dataDealer) {
    try {
      const response = await fetch(`/internal-api/dealer/base`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          ...dataDealer,
          country: "Russia",
          city: "Russia",
          address: "Russia",
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Ошибка: ", error);
    }
  }
}
